module.exports = __webpack_public_path__ + "static/img/courseBack.66a264b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/courseBack.jpg
// module id = DQNn
// module chunks = 1